import formatDateShort from "./date-short";
import formatDate from "./date";

export default function formatDaterange(range: MomentRange, collapseOneDay:boolean = false):string {

    if (!range || !range.start || !range.end) return ''

    // convert to Moment if not moment
    if (!moment.isMoment(range.start)) {
        range.start = moment(range.start)
    }

    if (!moment.isMoment(range.end)) {
        range.end = moment(range.end)
    }


    if (collapseOneDay && range.start.isSame(range.end, 'days')) {
        return formatDateShort(range.start, true)
    }



    return "{0} - {1}".f(
        formatDate(range.start),
        formatDate(range.end)
    )
}